import { render, staticRenderFns } from "./CertificationsTermsList.vue?vue&type=template&id=3bf507b6&scoped=true&"
import script from "./CertificationsTermsList.vue?vue&type=script&lang=js&"
export * from "./CertificationsTermsList.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTermsList.vue?vue&type=style&index=0&id=3bf507b6&lang=scss&scoped=true&"
import style1 from "./CertificationsTermsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf507b6",
  null
  
)

export default component.exports